/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * slider-normail.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Imprt swiper.
 */
import Swiper from "swiper/bundle";

/**
 * ページ別
 *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * HOME
 */
if (window.document.body.classList.contains("home")) {
  if (window.matchMedia("(max-width: 1024px)").matches) {
    const option__pageNav = {
      loop: true,
      slidesPerView: "auto",
      initialSlide: 0,
      centeredSlides: true,
      preventClicks: true,
      grabCursor: true,
    };

    const SliderDetail = new Swiper(".page-nav__slider", option__pageNav);
  }
}

/**
 * 14階建ハイグレード賃貸マンショングリーンスパーク109
 */
if (window.document.body.classList.contains("greenspark109")) {

  if (window.matchMedia("(min-width: 1025px)").matches) {
    var initialSlide = 1; var spaceBetween = 65;
  } else {
    var initialSlide = 0; var spaceBetween = 35;
  }

  const option__detail = {
    slidesPerView: "auto",
    slidesPerGroup: 1,
    initialSlide: initialSlide,
    centeredSlides: true,
    spaceBetween: spaceBetween,
    preventClicks: true,
    grabCursor: true,
    pagination: {
      el: '.detail__slider__pagination',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      prevEl: '.button__prev',
      nextEl: '.button__next',
    },
  };

  const SliderDetail = new Swiper(".detail__slider", option__detail);

  const option__safety = {
    loop: true,
    slidesPerView: 'auto',
    initialSlide: 0,
    centeredSlides: true,
    spaceBetween: 10,
    preventClicks: true,
    speed: 1500,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    grabCursor: true,
    navigation: {
      prevEl: '.button__prev',
      nextEl: '.button__next',
    },
  };

  const sliderSafety1 = new Swiper(".block__slider .slider__safety1", option__safety);
  const sliderSafety2 = new Swiper(".block__slider .slider__safety2", option__safety);
  const sliderSafety3 = new Swiper(".block__slider .slider__safety3", option__safety);

}

/**
 * 音楽イベントの企画運営・管理
 */
if (window.document.body.classList.contains("event-management")) {

  var eventSlider3DSlideLength = document.querySelectorAll('.slider__3d.slider__event .slide').length;
  var ArchiveSlider3DSlideLength = document.querySelectorAll('.slider__3d.slider__archive .slide').length;

  const option = {
    loop: true,
    slidesPerView: 'auto',
    initialSlide: 2,
    centeredSlides: true,
    effect: 'coverflow',
    grabCursor: true,
    speed: 1000,
    navigation: {
      prevEl: '.button__prev',
      nextEl: '.button__next',
    },
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 185,
      modifier: 1,
      slideShadows: false,
    },
  };

  if (eventSlider3DSlideLength >= 1) {
    const Slider3D__Event = new Swiper(".block__slider__3d .slider__3d.slider__event", option);
  }

  if (ArchiveSlider3DSlideLength >= 1) {
    const Slider3D__Archive = new Swiper(".block__slider__3d .slider__3d.slider__archive", option);
  }
}